import { useEffect } from 'react';
import type { Shipper } from 'src/apis/monolith/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';
import { useCognitoUser } from 'src/hooks/use-cognito-user';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

export function useOptionalShipperById(id: string) {
  const monolithUser = useOptionalAuthenticatedMonolithUser();
  const cognitoUser = useCognitoUser();

  const shipperById = useAxios(
    (axios, baseConfig, id: string) =>
      axios.request<Shipper>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/shippers/${id}`,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        // workaround for the case, when logged in user is an operator, which is not known to the monolith
        // and the shipper at the same time. In this case, monolith returns 403 as shipper as shippers
        // are not allowed to see the others shippers details.
        if (isServerError(error, 403)) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );

  useEffect(() => {
    if (cognitoUser && !monolithUser) return;
    shipperById.execute(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (cognitoUser && !monolithUser) return;

  return shipperById;
}

export type OptionalShipperByIdRequest = ReturnType<
  typeof useOptionalShipperById
>;
